module.exports = __webpack_public_path__ + "img/profile.d41c7771.svg";